import { Middleware, Context } from '@nuxt/types'

const setSharedData: Middleware = async ({ store }: Context): Promise<void> => {
  if (store.getters['context/isLocalMarketplace']) return

  await store.dispatch('contentful/fetchSharedData')
}
export default setSharedData
